import { useState } from 'react'
import {
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useGetMatricesQuery
} from 'prove-common'
import { MatricesTable } from '../tables/matrices-table/MatricesTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { MatrixForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const MatricesScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const { data: matrices, isFetching, isError, refetch } = useGetMatricesQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Matriser' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Matriser'
            description='Prøvemateriale som sammen med produkter definerer prøvetypene.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til matrise
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={matrices != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {matrices ? <MatricesTable matrices={matrices} /> : null}
      </ScreenLayout>
      {isModalOpen && <MatrixForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
